import React, {Component} from 'react';
import Select from 'react-select';
import {connect} from 'react-redux';
import cx from 'classnames';
import Modal from '../../components/Modal';
import {qualifyClient} from '../../actions/ClientActions';
import industries from '../../constants/industryList';

@connect(
    state => ({
        isSavingQualify: state.modal.isSavingQualify
    })
)
export default class QualifyModal extends Component {

	constructor(props){
		super(props);
		console.log("props", props.client.industryName, props.client.numberOfStaff);
		this.state = {
			industryName : props.client.industryName,
			reportedStaffCount : props.client.numberOfStaff
		}
	}

    qualify() {
        this.props.dispatch(qualifyClient({
        	clientId : this.props.client.id,
        	industryName : this.state.industryName,
        	reportedStaffCount : this.state.reportedStaffCount
        }));
    }
    
    handleIndustryChange(value){
    	this.setState({
    		industryName : value
    	});
    }

    handleStaffChange(e){
    	this.setState({
    		reportedStaffCount : e.target.value
    	})
    }

    render() {        
        var actionButton = this.props.isSavingQualify ?
            (<button className="btn btn-success disabled">Saving...</button>) :
            (<button className="btn btn-success" onClick={this.qualify.bind(this)}>Qualify Lead</button>);

        return (
            <Modal actionButton={actionButton} className="modal modal-success" title={"Qualify Client"}>
                <Select
                    placeholder="Select Industry..."
                    multi={false}
                    name="industryName"
                    value={this.state.industryName}
                    options={industries}
                    onChange={this.handleIndustryChange.bind(this)} />
                <br />

                <FormInput 
                    label="Number Of Staff"
                    value={this.state.reportedStaffCount}
                    name="numberStaff" 
                    onChange={this.handleStaffChange.bind(this)} 
                    placeholder="Select Number of staff.."
                />
            </Modal>
        );
    }
}

function FormInput({error, value, onChange, name, label, placeholder, style}) {
    var inputClassName = cx("c3-form-input", {'input-has-error': error});

    style = style ? style : {};
    style.marginBottom = style.marginBottom ? style.marginBottom : 15;

    return (
        <div className="input-wrapper" style={style}>
            <div className="input-wrapper-label">{label}</div>
            <input 
                style={{border: "1px solid #999"}}
                className={inputClassName}
                value={value} 
                name={name} 
                placeholder={placeholder} 
                onChange={onChange} />
        </div>
    );
}


// WEBPACK FOOTER //
// ./app/components/clients/QualifyModal.js